import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import HybridFormFieldTextinput from '../../shared/HybridFormFieldTextinput/hybrid.form.field.textinput.vue';
import * as T_T from 'cryface';
import { CommonConfig } from '../../../configs/config.common';
import { AxiosPromise } from '../../../utils/axios.promise';
import { HousePriceEvaluateValidator } from './validator';
import { CallNative } from '../../../services/EpicContextService/call.native';
import Stacked from '../../../shared/Stacked/stacked.vue';
import { EpicContextService } from '../../../services/EpicContextService/epic.context';
import { ILeadCreateForm, getSourceChannel, createLead } from '../../../utils/lead.manager';

@Component({
    components: {
        HybridFormFieldTextinput,
        Stacked
    }
})
export default class HybridHousePriceEvaluatePage extends Vue {
    public configs = new CommonConfig();

    public data: string = '';

    public searchText: string = '';

    public dropdownShow: boolean = false;

    // autoComplete
    public googleResult: any = null;

    public google: any = null;

    public googlePlaceResult: any = null;

    public requestTimeoutId: any = undefined;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public created() {
    }

    public mounted() {
        CallNative.setNativeNavTitle('RIFO 房屋评估', 'RIFO HOME VALUATION');
    }

    public keyboardWatch(event: any) {
        const text = this.searchText;
        clearTimeout(this.requestTimeoutId);
        if (T_T.simpleDetect(text)) {
            this.requestTimeoutId = setTimeout(async () => {
                // get Dropdown Content
                await this.autoByAddress(text);
                // DropDown Show
                this.dropdownShow = true;
            }, 300);
        }
    }

    public async autoByAddress(text: string) {
        if (text.length > 0) {
            this.googleResult = await this.autoCompleteGoogle();
        } else {
            this.googleResult = null;
            this.dropdownShow = false;
        }
    }

    public clearSearchbar() {
        this.searchText = '';
        this.googleResult = null;
        this.dropdownShow = false;
    }

    public async autoCompleteGoogle() {
        const apiHost = this.configs.analysisService;
        const google = `${apiHost}/google/autocomplete?searchtext=${this.searchText}`;
        const fetched = await AxiosPromise.get(google);
        if (fetched.code === 200) {
            return this.autoCompleteDataClean(fetched.data);
        }
        return null;
    }

    public autoCompleteDataClean(dataGotten: any) {
        return T_T.simpleDetect(dataGotten.predictions) ? dataGotten.predictions : [];
    }

    public dropDownOutside() {
        this.dropdownShow = false;
    }

    public onDropdownSelected(text: string) {
        this.searchText = text;
        this.dropdownShow = false;
    }

    public async getUser(fjjUserId: number) {
        const apiHost = this.configs.cmisapiHost;
        const body = {
            uid: fjjUserId,
            ltype: 1,
        };
        const fetched = await AxiosPromise.postJson(`${apiHost}/login/uid`, body);
        console.log(fetched);
        if (fetched.status === 200) {
            if (fetched.data.code === 200) {
                return fetched.data.data;
            } else {
                console.error('User Info Fetching Failed');
            }
        }
        return null;
    }

    public async handleSubmit() {
        const apiHost = this.configs.cmisapiHost;
        const fjjUserId = this.globalPudge.functions.getParam(EpicContextService.EEpicContextParams.fjjUserId);
        if (T_T.simpleDetect(fjjUserId)) {
            const validateResult = HousePriceEvaluateValidator.validator(this.searchText);
            if (!T_T.simpleDetect(validateResult)) {
                const user = await this.getUser(fjjUserId!.value);
                const leadForm: ILeadCreateForm = {
                    leadName: 'Lead From EpicWeb',
                    clientName: user.uName,
                    email: user.uEmail,
                    phone: ``,
                    registerAccount: false,
                    channel: getSourceChannel(this.$i18n.locale),
                };
                const result = await createLead(leadForm);
                console.log(result);
                this.$Notice.success({
                    title: 'Request Sent',
                    desc: 'Thank you.'
                });
                this.$router.push('/hybrid/success?text=We have get your apply, Our agent will connect your at once.');
            } else {
                this.$Notice.error({
                    title: 'Error',
                    desc: validateResult!
                });
            }
        } else {
            this.$Notice.error({
                title: 'No User Info Found',
                desc: 'Please Sign In First.'
            });
            console.warn('No User Info Found');
            CallNative.runNativeFun('nativeGoRegister');
        }
    }

    public getBanner() {
        return `${this.configs.rifoDesignAssetsUrl}/houseworth.jpg`;
    }
}
